import { Tools } from "../Services/Tools";

export const CATEGORY_PATHS = [
  'JSON Tools',
  'data',
  'api-diagram',
  'encode',
  'text',
  'generators',
  'diff',
  'crypto',
  'db',
  'time',
  'media',
  'documents',
];

const toolRoutes = {
  'JSON Tools': 'JSON Tools',
  'JSON Convertor': 'JSON Tools/Convertors',
  'JSON Converters': 'JSON Tools/Convertors',
  'JSON Formatter': 'JSON Tools/formatter',
  'JSON Validator': 'JSON Tools/validator',
  'JSON Difference': 'JSON Tools/Difference',
  'JSON Diff': 'JSON Tools/Difference',
  'JSON Evaluator': 'JSON Tools/Evaluator',
  'JSON Structure Analyzer': 'JSON Tools/Evaluator',

  'Data Format': 'data',
  'Data Format / Markup Tools': 'data',
  'XML Formatter': 'data/xmlFormatter',
  'HTML Formatter': 'data/htmlFormatter',
  'HTML Stripper': 'data/htmlStripper',
  'HTML Tag Remover': 'data/htmlStripper',
  'Markdown to HTML': 'data/htmlConverter',
  'OpenAPI Architect': 'data/api-tool',
  'API Tool': 'data/api-tool',
  APILens: 'data/api-tool',

  'API & Diagram Tools': 'api-diagram',
  Whiteboard: 'media/whiteboard',
  'Flowchart & Mermaid Builder': 'media/whiteboard',
  Flowlens: 'media/whiteboard',
  FlowLens: 'media/whiteboard',
  flowlens: 'media/whiteboard',

  'Encode/Decode': 'encode',
  'Encode / Decode': 'encode',
  'Encoder / Decoder': 'encode',
  'Base64 Encode/Decode': 'encode/base64',
  'Base64 Encoder/Decoder': 'encode/base64',
  'Base64 URL Encode/Decode': 'encode/base64url',
  'Base64URL Encoder/Decoder': 'encode/base64url',
  'URL Encode/Decode': 'encode/URL',
  'URL Encoder/Decoder': 'encode/URL',
  'HTML Encode/Decode': 'encode/html',
  'HTML Encoder/Decoder': 'encode/html',
  'HTML Entity Encoder/Decoder': 'encode/html',
  'Hex Encode/Decode': 'encode/hex',
  'Hex Encoder/Decoder': 'encode/hex',
  'Quoted Printable Encode/Decode': 'encode/quoted_printable',
  'Quoted Printable': 'encode/quoted_printable',
  'Quoted-Printable Encoder/Decoder': 'encode/quoted_printable',
  'ASCII to Bytes Converter': 'encode/ascii',
  'ASCII Bytes Converter': 'encode/ascii',

  'Text Utilities': 'text',
  'Case Converter': 'text/caseconverters',
  'Character count': 'text/counters',
  Counters: 'text/counters',
  'Word & Character Counter': 'text/counters',
  'Text Counter': 'text/counters',
  'Escape/Unescape': 'text/escape-unescape',
  'Trim/Collapse': 'text/whitespace-trim',
  'Whitespace Trim': 'text/whitespace-trim',
  'Whitespace Trim & Collapse': 'text/whitespace-trim',
  'Whitespace Cleaner': 'text/whitespace-trim',
  'LoremIpsum Generator': 'text/lorem-ipsum-generator',
  'Lorem Ipsum Generator': 'text/lorem-ipsum-generator',
  'Random string Generator': 'text/random-string-generator',
  'Random String Generator': 'text/random-string-generator',
  'Find and replace': 'text/find-replace',
  'Find and Replace': 'text/find-replace',
  'Find & Replace': 'text/find-replace',
  'Regex tester': 'text/regex-tester',
  'Regex Pattern Tester': 'text/regex-tester',
  'Regex Tester': 'text/regex-tester',

  'Identifier / Value Generators': 'generators',
  'UUID Generator': 'text/uuid-generator',
  'Color picker': 'text/color-picker',
  'Color Picker': 'text/color-picker',

  'Diff Tools': 'diff',
  'Text Diff': 'diff/text',
  'CSV Diff': 'diff/CSV',
  'XML Diff': 'diff/XML',

  'Crypto & Security': 'crypto',
  'Hash Generator': 'crypto/hash',
  'HMAC Generator': 'crypto/hmac',
  'HMAC Calculator': 'crypto/hmac',
  'Argon2 Hash': 'crypto/argon2',
  'Argon2 Hasher': 'crypto/argon2',
  'JWT Encode/Decode': 'crypto/jwt',
  'JWT Decoder/Encoder': 'crypto/jwt',
  'BCrypt Hash': 'crypto/bcrypt',
  'Bcrypt Hash': 'crypto/bcrypt',
  'BCrypt Hasher': 'crypto/bcrypt',

  'Database Tools': 'db',
  'JSON to SQL Converter': 'db/jsontoSQL',
  'JSON to SQL': 'db/jsontoSQL',
  'CSV to SQL Converter': 'db/csvtoSQL',
  'CSV to SQL converter': 'db/csvtoSQL',
  'CSV to SQL': 'db/csvtoSQL',

  'Time & Date': 'time',
  'Cron Parser': 'time/CronParser',
  'Cron Parser & Generator': 'time/CronParser',
  'Timezone Converter': 'time/timezone',
  'Time Zone Converter': 'time/timezone',
  'Time Difference Calculator': 'time/time-difference',
  'Timestamp converter': 'time/time-stamp',
  'Timestamp Converter': 'time/time-stamp',

  'Image/PDF': 'media',
  'Image / PDF': 'media',
  'Image / PDF Tools': 'media',
  'Image Tools': 'media/image-tools',
  'Image Converter': 'media/image-tools',
  'Base64 Image Tools': 'media/base64-image',
  'Base64 Image Converter': 'media/base64-image',
  'PDF & Image tools': 'media/pdf-image',
  'PDF and Image Tools': 'media/pdf-image',
  'PDF Image Converter': 'media/pdf-image',
  'PDF merger and splitter': 'media/pdf-merger',
  'PDF Merger & Splitter': 'media/pdf-merger',

  'Document Tools': 'documents',
  'Docx to PDF': 'media/docxtopdf',
  'Docx to PDF Converter': 'media/docxtopdf',
  'DOCX to PDF': 'media/docxtopdf',
  'Docx to Markdown': 'media/docxtomarkdown',
  'Docx to Markdown Converter': 'media/docxtomarkdown',
  'DOCX to Markdown': 'media/docxtomarkdown',
};

export const getToolRoute = (toolName) => toolRoutes[toolName] || '/';

// The Image Tools category reuses a legacy tool label; preserve old favorite routes.
export const getCategoryRoute = (categoryName) => categoryName === 'Image Tools' ? 'media' : getToolRoute(categoryName);

// A tool may live outside its category URL after regrouping. Always use its full path.
export const getCategoryToolRoute = (toolName) => {
  const route = getToolRoute(toolName);
  return route === '/' ? '/app/tools' : '/app/tools/' + route;
};

const canonicalNamesByRoute = new Map(
  Tools.flatMap(category => category.SubCategory.map(tool => [getToolRoute(tool.SubCategory), tool.SubCategory]))
);

export const getCanonicalToolName = (toolName) => canonicalNamesByRoute.get(getToolRoute(toolName)) || toolName;

// Display branding only: preserve route keys, saved favorites and the public catalog.
export const getToolDisplayName = (toolName) => ({
  APILens: 'API Lens',
  Flowlens: 'Flow Lens',
})[getCanonicalToolName(toolName)] || toolName;
